/**
 * Import all Block Reveal Effects functionality for Front-End.
 *
 * File serves as an entry point for webpack.
 */
import "./frontend/reveal-effects";
